// extracted by mini-css-extract-plugin
export var accordionCard = "style-mod--accordion-card--c3c4b";
export var accordionIcon = "style-mod--accordion-icon--debd6";
export var accordionIconOpen = "style-mod--accordion-icon-open--07c27";
export var accordionSubtitle = "style-mod--accordion-subtitle--6a3e9";
export var accordionTitle = "style-mod--accordion-title--aa76f";
export var cardHeader = "style-mod--card-header--01801";
export var category = "style-mod--category--2ce30";
export var content = "style-mod--content--8c7de";
export var imageTable = "style-mod--image-table--df1a4";
export var pdTitle = "style-mod--pd-title--b2274";
export var productDetailsAccordion = "style-mod--product-details-accordion--e3fe8";
export var productDetailsAccordionImg = "style-mod--product-details-accordion-img--b0557";
export var productDetailsAccordionReverse = "style-mod--product-details-accordion-reverse--30893";
export var productImage = "style-mod--product-image--0ca05";